import { Dispatch, SetStateAction, useRef, useState } from "react";
import { EmpresasVisitadas, VendedorForDashboard } from "../../../types/vendedor";
import { GeneralInformationCard } from "./GeneralInformationCard";
import { useLazyGetEmpresaInfoByIdQuery } from "../../../features/empresas/empresaApi";

interface Props {
    vendedor: VendedorForDashboard;
}

export function CardEmpresasVendedor({ vendedor }: Props) {


    const selectColorStatus = (status: string) => {
        if(status == "Nocturno")
            return "green";

        if(status == "Reactivada" || status == "NUEVA")
            return "red";
        
        return "gray";
    }

    const cardEmpresaRef = useRef<HTMLDivElement>(null);
    const [openCard, setOpenCard] = useState(false);
    const [empresaSelected, setEmpresaSelected] = useState<number | null>(null);
    const [modalPosition, setModalPosition] = useState<{ top: number; left: number; }>({
        top: 0,
        left: 0,
    });


    const toggleModal = (empresa: EmpresasVisitadas, element: HTMLDivElement) => {
        const rect = element.getBoundingClientRect();
        setModalPosition({
            top: 0,
            left: rect.width,
        });
        setEmpresaSelected(empresa.id);

        if(openCard) return;
        setOpenCard(true);
    }

    const handleClick = (empresa: EmpresasVisitadas) => {
        if (cardEmpresaRef.current) {
            toggleModal(empresa, cardEmpresaRef.current);
        }
    }

    return (
        <div className="relative">

        <div 
            ref={cardEmpresaRef}
            className="border-2 border-slate-200 shadow-sm rounded w-[300px] h-[250px] flex flex-col">

            <div className="h-[70px]">
                <p className=" my-2 text-center font-semibold text-lg">{vendedor.nombre}</p>
                <p className="font-semibold mx-3 my-2">Empresas visitadas: {vendedor.empresas.length}</p>
            </div>

            <div className="h-full overflow-auto">
                {vendedor.empresas.map((empresa, index) => {
                    const color = selectColorStatus(empresa.status);
                    const backgroundColor = `bg-${color}-100`;
                    const borderColor = `border-${color}-500`;
                    return (
                    <div 
                        key={index}
                        onClick={() => handleClick(empresa)}
                        className={`flex rounded mx-2 ${backgroundColor} my-1 border-2 ${borderColor} cursor-pointer`}>
                        <p className={`font-semibold px-2 text-sm`}>{empresa.nombre}</p>
                    </div>
                    )
                })}
            </div>

        </div>

        {openCard && (
            <div
                className="z-[1000] absolute"
                style={{ top: modalPosition.top, right: modalPosition.left }}>
                <GeneralInformationCard
                    empresaSelected={empresaSelected}
                    setOpenCard={setOpenCard}/>
            </div>
        )}

        </div>
    );
}